export const dict = {
  cz: {
    nav: {
      add: "Přidat sraz",
      login: "Přihlásit",
      search_placeholder: "Hledat akci, město, zemi…",
      language: "Jazyk",
    },
    tagline: "Klikni a leť.",
    subtitle: "Srazy, výlety, festivaly a letenky s partou. Aktualizujeme denně.",
    filters: {
      all: "Vše",
      category: "Typ",
      country: "Země",
      region: "Kraj",
      hot: "🔥 Hot",
      clear: "Vyčistit filtry",
    },
    categories: {
      all: "Vše",
      letenky: "Letenky",
      zajezd: "Zájezd",
      vylet: "Výlet",
      koncert: "Koncert",
      festival: "Festival",
      sraz: "Sraz",
    },
    card: {
      join: "Připojit se",
      detail: "Detail",
      free: "Zdarma",
      seats_left: "volných míst",
      sold_out: "Plně obsazeno",
      attendees: "lidí jde",
    },
    detail: {
      back: "Zpět",
      info: "Co je v ceně",
      organizer: "Organizátor",
      capacity: "Kapacita",
      date: "Datum",
      where: "Kde",
      reserve: "Rezervovat místo",
      reserve_soon: "Rezervace brzy",
    },
    empty: {
      title: "Žádné akce nesedí filtrům",
      desc: "Zkus vyčistit filtry nebo přidej vlastní sraz.",
    },
    footer: {
      tagline: "ConnectYou.cz — najdi partu, najdi sebe.",
      safety: "Bezpečné prostředí · ověření profilů (brzy)",
    },
  },
  sk: {
    nav: {
      add: "Pridať stretko",
      login: "Prihlásiť",
      search_placeholder: "Hľadať akciu, mesto, krajinu…",
      language: "Jazyk",
    },
    tagline: "Klikni a leť.",
    subtitle: "Stretká, výlety, festivaly a letenky s partou. Aktualizujeme denne.",
    filters: {
      all: "Všetko",
      category: "Typ",
      country: "Krajina",
      region: "Kraj",
      hot: "🔥 Hot",
      clear: "Vyčistiť filtre",
    },
    categories: {
      all: "Všetko",
      letenky: "Letenky",
      zajezd: "Zájazd",
      vylet: "Výlet",
      koncert: "Koncert",
      festival: "Festival",
      sraz: "Stretko",
    },
    card: {
      join: "Pripojiť sa",
      detail: "Detail",
      free: "Zdarma",
      seats_left: "voľných miest",
      sold_out: "Plne obsadené",
      attendees: "ľudí ide",
    },
    detail: {
      back: "Späť",
      info: "Čo je v cene",
      organizer: "Organizátor",
      capacity: "Kapacita",
      date: "Dátum",
      where: "Kde",
      reserve: "Rezervovať miesto",
      reserve_soon: "Rezervácie čoskoro",
    },
    empty: {
      title: "Žiadne akcie nesedia filtrom",
      desc: "Skús vyčistiť filtre alebo pridaj vlastné stretko.",
    },
    footer: {
      tagline: "ConnectYou.cz — nájdi partu, nájdi seba.",
      safety: "Bezpečné prostredie · overenie profilov (čoskoro)",
    },
  },
  en: {
    nav: {
      add: "Add meetup",
      login: "Log in",
      search_placeholder: "Search event, city, country…",
      language: "Language",
    },
    tagline: "Click and fly.",
    subtitle: "Meetups, trips, festivals and flights with a crew. Updated daily.",
    filters: {
      all: "All",
      category: "Type",
      country: "Country",
      region: "Region",
      hot: "🔥 Hot",
      clear: "Clear filters",
    },
    categories: {
      all: "All",
      letenky: "Flights",
      zajezd: "Group trip",
      vylet: "Road trip",
      koncert: "Concert",
      festival: "Festival",
      sraz: "Meetup",
    },
    card: {
      join: "Join",
      detail: "Details",
      free: "Free",
      seats_left: "seats left",
      sold_out: "Sold out",
      attendees: "going",
    },
    detail: {
      back: "Back",
      info: "What's included",
      organizer: "Organizer",
      capacity: "Capacity",
      date: "Date",
      where: "Where",
      reserve: "Reserve a seat",
      reserve_soon: "Booking soon",
    },
    empty: {
      title: "No events match your filters",
      desc: "Try clearing the filters or add your own meetup.",
    },
    footer: {
      tagline: "ConnectYou.cz — find your crew, find yourself.",
      safety: "Safe space · profile verification (soon)",
    },
  },
};

export const LANG_NAMES = { cz: "CZ", sk: "SK", en: "EN" };

export function tr(lang, path) {
  const parts = path.split(".");
  let cur = dict[lang] || dict.cz;
  for (const p of parts) {
    if (cur == null) return path;
    cur = cur[p];
  }
  return cur ?? path;
}
